<nz-layout>
    <nz-affix>
        <nz-header class="flex flex-row items-center justify-between gap-4">
            <div class="flex flex-row items-center gap-4 justify-start">
                <button nz-button nzType="link" (click)="closeDrawer()">
                    <i class="fa-solid fa-x"></i>
                </button>
                <span class="font-bold">Type: &nbsp;</span>
                <nz-select
                    style="min-width: 300px; max-width: 750px"
                    nzPlaceHolder="Select"
                    nzShowSearch
                    nzAllowClear
                    [formControl]="questionnairesCtrl"
                    *ngIf="!consultation; else label"
                >
                    <nz-option
                        *ngFor="let q of availableQnrs"
                        [nzLabel]="q.name"
                        [nzValue]="q.key"
                    ></nz-option>
                </nz-select>

                <ng-template #label>
                    <span class="font-bold">{{ qnrLabel }}</span>
                </ng-template>
            </div>

            <div
                *ngIf="$questionnaire | async"
                class="ml-auto flex flex-row items-center gap-6"
            >
                <div class="flex flex-row items-center">
                    <label nz-checkbox [(ngModel)]="internal">Internal</label>
                    <span
                        nz-icon
                        nzType="question-circle"
                        nzTheme="outline"
                        nz-tooltip
                        nzTooltipTitle="Internal questionnaires are accessible by the staff only; patients will not be able to view it."
                    ></span>
                </div>
                <button
                    nz-button
                    nzType="primary"
                    [nzLoading]="isLoading"
                    (click)="submit()"
                >
                    Create
                </button>
            </div>
        </nz-header>
    </nz-affix>
    <nz-content>
        <ng-container *ngIf="$questionnaire | async">
            <form #ngForm="ngForm">
                <my-health-admin-form-engine
                    [questions]="questions"
                    [data]="answers"
                    [brand]="org"
                    [customerId]="customerId"
                ></my-health-admin-form-engine>
            </form>
        </ng-container>
        <h3 class="error">{{ error }}</h3>
    </nz-content>
</nz-layout>
